export default __webpack_public_path__ + "assets/models/37c10d3062104452f6fc49ba6af9bf14.glb";